module.exports = __webpack_public_path__ + "static/bio-45ebcbe6d338a44b816b6a01663180f1.jpg";